export default function stickyDatepicker() {
  const arrivalsDeparturesPage = document.getElementsByClassName("js--arrivals-departures-page-module")
  const mobileDatepickerContainer = arrivalsDeparturesPage[0].querySelectorAll(".mobile-datepicker-container")
  if (mobileDatepickerContainer.length > 0) {
    let pickerContainer = mobileDatepickerContainer[0]
    let datePicker = pickerContainer.querySelector(".mobile-datepicker")
    let containerTop = pickerContainer.getBoundingClientRect().top
    let buttonContainer = arrivalsDeparturesPage[0].querySelector(".buttoncontainer")
    if (buttonContainer && datePicker) {
      const pickerHeight = datePicker.clientHeight
      if (containerTop <= 0) {
        handleDatePickerSticky(datePicker, pickerContainer, containerTop, pickerHeight, arrivalsDeparturesPage)
      } else {
        handleDatePickerNotSticky(datePicker, pickerContainer)
      }
      let buttonContainerTop = buttonContainer.getBoundingClientRect().top
      handleButtonContainerTop(buttonContainerTop, pickerHeight, datePicker)
      handleDateSelect(datePicker, arrivalsDeparturesPage)
    }
  }
}

function handleDatePickerSticky(datePicker, pickerContainer, containerTop, pickerHeight, arrivalsDeparturesPage) {
  let input = arrivalsDeparturesPage[0].querySelector("#searchTextbox")
  if (input.classList.contains("ios") && input.classList.contains("focus")) {
    input.blur()
  }
  datePicker.classList.add("is-sticky")
  if (datePicker.dataset.isMobile === "false") {
    datePicker.style.display = null
  } else {
    pickerContainer.style.height = pickerHeight + "px"
  }
}

function handleDatePickerNotSticky(datePicker, pickerContainer) {
  datePicker.classList.remove("is-sticky")
  if (datePicker.dataset.isMobile === "false") {
    datePicker.style.display = "none"
  } else {
    pickerContainer.style.height = null
  }
}

function handleButtonContainerTop(buttonContainerTop, pickerHeight, datePicker) {
  if (buttonContainerTop <= pickerHeight) {
    datePicker.style.visibility = "hidden"
  } else {
    datePicker.style.visibility = null
  }
}

function handleDateSelect(datePicker, arrivalsDeparturesPage) {
  const dateSelect = datePicker.querySelector(".dateselect")
  if (datePicker.classList.contains("is-sticky") && !dateSelect.classList.contains("datepicker-open")) {
    handleFlightSection(datePicker, arrivalsDeparturesPage)
  } else if (!datePicker.classList.contains("is-sticky") && !dateSelect.classList.contains("datepicker-open")) {
    handleFlightRows(datePicker, arrivalsDeparturesPage)
  }
}

function handleFlightSection(datePicker, arrivalsDeparturesPage) {
  const flightSection = arrivalsDeparturesPage[0].querySelector("#FlightSection")
  if (flightSection) {
    const dateHeaders = flightSection.getElementsByClassName("flight-date-header")
    if (dateHeaders.length > 0) {
      handleDateHeaders(datePicker, dateHeaders, arrivalsDeparturesPage)
    }
  }
}

function handleFlightRows(datePicker, arrivalsDeparturesPage) {
  const flightSection = arrivalsDeparturesPage[0].querySelector("#FlightSection")
  if (flightSection) {
    const flightRows = flightSection.getElementsByClassName("flight-row")
    if (flightRows.length > 0) {
      const firstRow = flightRows[0]
      const datePickerLabel = datePicker.querySelector(".datepicker-label")
      const date = firstRow.getAttribute("data-date")
      datePickerLabel.innerHTML = date
    }
  }
}

function handleDateHeaders(datePicker, dateHeaders, arrivalsDeparturesPage) {
  const datePickerBottom = datePicker.getBoundingClientRect().bottom
  const datePickerLabel = datePicker.querySelector(".datepicker-label")
  for (let elem of dateHeaders) {
    const elemBottom = elem.getBoundingClientRect().bottom
    if (elemBottom <= datePickerBottom) {
      datePickerLabel.innerHTML = elem.getAttribute("data-date")
    }
  }
  const firstDateHeader = dateHeaders[0]
  const firstDateHeaderBottom = firstDateHeader.getBoundingClientRect().bottom
  if (firstDateHeaderBottom > datePickerBottom) {
    const flightSection = arrivalsDeparturesPage[0].querySelector("#FlightSection")
    const flightRows = flightSection.getElementsByClassName("flight-row")
    if (flightRows.length > 0) {
      const firstRow = flightRows[0]
      const datePickerLabel = datePicker.querySelector(".datepicker-label")
      const date = firstRow.getAttribute("data-date")
      datePickerLabel.innerHTML = date
    }
  }
}
